/**
 * Production-safe logger utility
 * Only outputs to console in development mode
 */

const isDev = import.meta.env.DEV || import.meta.env.MODE === 'development';

const logger = {
  log: (...args) => {
    if (isDev) console.log(...args);
  },
  
  warn: (...args) => {
    if (isDev) console.warn(...args);
  },
  
  error: (...args) => {
    // Always log errors, but sanitize in production
    if (isDev) {
      console.error(...args);
    } else {
      // In production, log a generic message without sensitive details
      console.error('An error occurred. Check application logs for details.');
    }
  },
  
  // For critical errors that should always be logged (but sanitized)
  critical: (...args) => {
    console.error('[CRITICAL]', ...args);
  },
  
  // Debug-only logging (never in production)
  debug: (...args) => {
    if (isDev) console.debug('[DEBUG]', ...args);
  },
  
  // Group logging for organized output
  group: (label) => {
    if (isDev) console.group(label);
  },
  
  groupEnd: () => {
    if (isDev) console.groupEnd();
  },
  
  // Table logging for data structures
  table: (data) => {
    if (isDev) console.table(data);
  }
};

export default logger;
